export default {
  main: "%{title} | FleetYards.net",
  home: "Home",
  search: "Risultati Ricerca",
  models: { index: "Navi" },
  model: "%{name} - %{manufacturer}",
  modelImages: "%{name} Immagini",
  modelVideos: "%{name} Video",
  images: "Immagini",
  stats: "Statistiche",
  login: "Login",
  signUp: "Registrati",
  hangar: {
    index: "Il Mio Hangar",
    preview: "Anteprima del Mio Hangar",
    stats: "Statistiche del Mio Hangar",
    import: "Importa",
    public: "Hangar di %{user}",
    wishlist: "Wishlist",
    publicWishlist: "%{user} Wishlist",
  },
  stations: "Stazioni",
  shops: "Negozi",
  starsystems: "Sistemi Stellari",
  starsystem: "Sistema Stellare %{starsystem}",
  celestialObject: "%{celestialObject} nel Sistema di %{starsystem}",
  station: "%{station} vicino a %{celestialObject}",
  stationImages: "Immagini di %{station} vicino a %{celestialObject}",
  shop: "%{shop} su %{station}",
  requestPassword: "Richiedi la password",
  changePassword: "Cambia la password",
  fleets: {
    add: "Crea una nuova Flotta",
    preview: "Anteprima della Flotta",
    invites: "Inviti Alla Flotta",
    members: "Membri di %{fleet}",
    stats: "Statistiche di %{fleet}",
    settings: "Impostazioni di %{fleet}",
  },
  roadmap: {
    index: "Roadmap",
    ships: "Roadmap Delle Navi",
    changes: "Modifiche alla Roadmap",
  },
  settings: {
    index: "Impostazioni del Profilo",
    account: "Account",
    hangar: "Impostazioni dell'Hangar",
    notifications: "Impostazioni Notifiche",
    security: "Sicurezza dell'account",
    twoFactor: {
      enable: "Attiva Autenticazione A Due Fattori",
      disable: "Disattiva Autenticazione A Due Fattori",
      backupCodes: "Genera Codici Di Backup Autenticazione a Due Fattori",
    },
  },
  compare: { models: "Confronta Navi" },
  notFound: "404",
  tools: {
    profitCalculator: "Calcolatore Dei Profitti",
    tradeRoutes: "Rotte Commerciali",
  },
  commodities: "Merci",
  impressum: "Info legali",
  privacyPolicy: "Informativa sulla privacy",
  cookiePolicy: "Informativa sui Cookie",
};
